var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    ref: "chatBody",
    staticClass: "chat-body"
  }, _vm._l(_vm.messages, function (msg, index) {
    return _c('div', {
      key: index,
      class: ['message-row', msg.roleType === 'SELLER' ? 'agent' : 'customer']
    }, [_vm._m(0, true), _c('div', {
      staticClass: "message"
    }, [_vm._v(_vm._s(msg.text))])]);
  }), 0), _c('div', {
    staticClass: "chat-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.newMessage,
      expression: "newMessage"
    }],
    attrs: {
      "placeholder": "Write a message..."
    },
    domProps: {
      "value": _vm.newMessage
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.sendMessage.apply(null, arguments);
      },
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.newMessage = $event.target.value;
      }
    }
  }), _c('button', {
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v("➤")])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "avatar"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]);

}]

export { render, staticRenderFns }